import { createFileRoute } from "@tanstack/react-router"

import { PrivacyPage } from "@/pages/(guest)/privacy/page"

export const Route = createFileRoute("/_guest/privacy")({
  component: PrivacyPage,
})
